import React from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import Sidebar from '../components/Sidebar';
import Button from '@mui/material/Button';
import OrganizationSelector from '../components/OrganizationSelector';
const Header = () => {
  return (
    <header className="mb-3" >
      <AppBar sx={{ bgcolor: "paper", top: 0 }} position="fixed">
      <Toolbar sx={{p: 0}}>
          <Sidebar open={true} onClose={() => console.log('Close') } />
          <Typography
            noWrap
            component={Link}
            to="/cases"
            sx={{
              mr: 2,
              fontFamily: 'Roboto Slab',
              fontSize: "16pt",
              display: { xs: 'none', md: 'flex' },
              fontWeight: 900,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            lemon.law assistant 
          </Typography>
          <OrganizationSelector />
      </Toolbar>
    </AppBar>
    </header>
  );
};

export default Header;
